// React hook to check window size on load and resize of the screen
// https://stackoverflow.com/questions/36862334/get-viewport-window-height-in-reactjs/36862446#36862446
import { useEffect, useState } from "preact/hooks";

/* istanbul ignore next */
function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

export default function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
}
